import React, { useEffect, useState } from "react"
import {
  Spinner,
} from "reactstrap";
import Header from "../../component/Header";
import { FullWrap, RightWrap, TableWrap, Loader } from "./styles";
import SideBar from "../../component/SideBar";
// import Modaldoctor from "../../component/Modaldoctor";
// import ReactTable from 'react-table-6'
import Dashboard from "../dashboard";
import { getDoctor } from "../../doctorapi";
import moment from "moment";
import { toast } from "react-toastify";


const Landing = () => {
    const data = [{
        name: 'Tanner Linsley',
        age: 26,
        friend: {
            name: 'Jason Maurer',
            age: 23,
        }
    }]

    const columns = [{
        Header: 'Name',
        accessor: 'name' // String-based value accessors!
    }, {
        Header: 'Age',
        accessor: 'age',
        Cell: props => <span className='number'>{props.value}</span> // Custom cell components!
    }, {
        id: 'friendName', // Required because our accessor is not a string
        Header: 'Friend Name',
        accessor: d => d.friend.name // Custom value accessors!
    }, {
        Header: props => <span>Friend Age</span>, // Custom header components!
        accessor: 'friend.age'
    }]

  const [isedit, setisedit] = useState(false);
  const [modal, setModal] = useState(false);
  const [checkAlldata, setCheckAllData] = useState(false);
  const [getAllData, setGetAllData] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    getDoctor().then(response => {
      let newdata = response.data.body.map(item => {
        let dataformat = item.createdAt
        item['updatedate'] = moment(dataformat).format( "MM/DD/YYYY");
        return item
      })
      setGetAllData([...newdata])
      setCheckAllData(true)
    }).catch(error => {
      notify("error")
    })
  }, [])

  const notify = msg => {
    if (msg == "error") {
      toast.error("Internal Server Error")
    } else if (msg == "success") {
      toast.success("Doctor Created Successfully")
    }
    else if (msg == "editsuccess") {
      toast.success("Doctor Updated Successfully")
    }
    else if (msg == "logoutsuccess") {
      toast.success("Logout Successfully")
    } else if (msg == "uniqueerror") {
      toast.error("Doctor Already Exist")
    }
  }

    return (
        <div>
            <Header />
            <FullWrap>
                <SideBar setisedit={setisedit} setModal={setModal} checkAlldata={checkAlldata} getAllData={getAllData}
                setShowLoading={setShowLoading}
                />
                <RightWrap>
                    <TableWrap>
                       <Dashboard
                        isedit={isedit} setisedit={setisedit} 
                        modal={modal} setModal={setModal}
                        checkAlldata={checkAlldata} setCheckAllData={setCheckAllData}
                        getAllData={getAllData} setGetAllData={setGetAllData}
                        />
                    </TableWrap>
                </RightWrap>
                {showLoading &&
                  <Loader>
                     <Spinner
                        as="span"
                        animation="border"
                        variant="danger"
                        aria-hidden="true"
                      />
                  </Loader>}
            </FullWrap >
        </div>
    )
}

export default Landing



// WEBPACK FOOTER //
// ./src/views/Landing/index.js